import { render, staticRenderFns } from "./send-box.vue?vue&type=template&id=2f6d0fd6"
import script from "./send-box.vue?vue&type=script&lang=js"
export * from "./send-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6d0fd6')) {
      api.createRecord('2f6d0fd6', component.options)
    } else {
      api.reload('2f6d0fd6', component.options)
    }
    module.hot.accept("./send-box.vue?vue&type=template&id=2f6d0fd6", function () {
      api.rerender('2f6d0fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/send-box.vue"
export default component.exports